
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Calque_1","data-name":"Calque 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 800 800"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('p')]),_c('g',[_c('circle',{staticClass:"cls-1",attrs:{"cx":"400","cy":"400","r":"400"}}),_c('g',[_c('rect',{staticClass:"cls-2",attrs:{"x":"418.65","y":"198.31","width":"80","height":"401.94","rx":"9.34","ry":"9.34","transform":"translate(380.93 -203.83) rotate(41.62)"}}),_c('rect',{staticClass:"cls-2",attrs:{"x":"253.13","y":"359.27","width":"80","height":"229.07","rx":"7.45","ry":"7.45","transform":"translate(846.09 542.02) rotate(128.78)"}})])])])
          )
        }
      }
    